<div class="page-title-area reseller-hosting-title">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Cómputo en la Nube</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Cómputo en la Nube</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Principales Usos</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-rocket"></i>
                            <h3>Empresas Emergentes</h3>
                            <p>Escala tu negocio sin invertir en personal, hardware y mantenimiento costoso.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-building"></i>
                            <h3>Corporativos</h3>
                            <p>Migración de servidores físicos a la nube para mayor flexibilidad y seguridad.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-book-atlas"></i>
                            <h3>Investigación</h3>
                            <p>Procesamiento de datos para proyectos de ciencia y tecnología.
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>


<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">¿Qué es el Cómputo en la Nube?</h2>
                    <p class="text-justify">El cómputo en la nube permite ejecutar aplicaciones y procesar datos sin la necesidad de adquirir ni mantener servidores físicos. En lugar de depender de infraestructura propia, puedes acceder a recursos escalables en la nube de enCloud, con la flexibilidad de aumentar o reducir tu consumo en segundos.</p>
                </div>


            </div>


        </div>
    </div>
</section>

<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">Potencia y Escalabilidad para Cualquier Necesidad</h2>
                    <p class="text-justify">Ofrecemos soluciones de cómputo en la nube diseñadas para empresas, desarrolladores, investigadores y startups que buscan potencia, flexibilidad y seguridad, sin costos ocultos ni complicaciones. Desde servidores virtuales hasta infraestructura escalable, nuestra nube está optimizada para cargas de trabajo exigentes y alta disponibilidad.</p>
                </div>

                <ul class="custom-list">
                    <p><strong>Beneficios del Cómputo en la Nube con nosotros:</strong></p>
                    <li> <strong>Escalabilidad en segundos</strong> – Aumenta o reduce recursos según la demanda.</li>
                    <li><strong>Alto rendimiento</strong> – Infraestructura optimizada con hardware de última generación.</li>
                    <li><strong>Menor latencia</strong> – Data centers en México para mayor velocidad.</li>
                    <li><strong>Costos competitivos</strong> – Pagos accesibles y sin sorpresas.</li>
                    <li><strong>Soporte en español</strong> – Asistencia 24/7 con expertos en la nube.</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Nuestros Servicios de Cómputo en la Nube</h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-server"></i>
                            <h3>Servidores Virtuales (VPS)</h3>
                            <p>Infraestructura escalable y flexible para alojar <span class="highlight">aplicaciones,
                                    sitios web y bases de datos</span>.</p>
                            <div class="row">


                                <a>🔹 Procesadores de alto rendimiento</a>
                                <a>🔹 Opciones con <span class="highlight">GPU</span> para gráficos e IA</a>
                                <a>🔹 Planes flexibles según el uso</a>
                                <p class="example"><strong>Ejemplo de uso:</strong> Una startup lanza su plataforma web
                                    en un VPS, escalando los recursos a medida que crece su tráfico.</p>

                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-bars-progress"></i>
                            <h3>Infraestructura como Servicio (IaaS)</h3>
                            <p>Lanza servidores en minutos y ajusta su capacidad según la demanda.</p>

                            <div class="row">
                                <a>🔹 Ideal para <span class="highlight">grandes empresas y empresa emergentes (startups)</span></a>
                                <a>🔹 Máquinas virtuales preconfiguradas o personalizadas</a>
                                <a>🔹 Integración con herramientas <span class="highlight">DevOps y CI/CD</span></a>
                                <p class="example"><strong>Ejemplo de uso:</strong> Una empresa de e-commerce usa IaaS
                                    para manejar picos de
                                    tráfico en temporadas altas sin interrupciones.</p>

                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-gears"></i>
                            <h3>Plataforma como Servicio (PaaS)</h3>
                            <p>Desarrolla, ejecuta y gestiona aplicaciones sin preocuparte por la infraestructura.</p>

                            <div class="row">

                                <a>🔹 Entornos preconfigurados para desarrollo</a>
                                <a>🔹 Soporte para <span class="highlight">múltiples lenguajes y marcos de trabajo</span></a>
                                <a>🔹 Integración con bases de datos y servicios cloud</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Un equipo de desarrolladores utiliza
                                    PaaS para desplegar
                                    y probar su aplicación sin preocuparse por la configuración del servidor.</p>

                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-robot"></i>
                            <h3>Cómputo para Inteligencia Artificial y Big Data</h3>
                            <p>Procesamiento masivo de datos con servidores optimizados para IA y análisis avanzado.</p>

                            <div class="row">



                                <a>🔹 Servidores con <span class="highlight">GPUs</span> para entrenar modelos de
                                    Machine Learning</a>
                                <a>🔹 Capacidades de cómputo para <span class="highlight">Big Data</span></a>
                                <a>🔹 Opciones de almacenamiento optimizadas para grandes volúmenes de datos</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Un equipo de investigación usa
                                    nuestros servidores para
                                    entrenar modelos de IA que analizan imágenes médicas.</p>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>





<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>